import { ReactElement, useMemo, useCallback } from 'react';

import { RouteReportCollectedItemsDriver } from '~services/route/report/types';
import TrackingInTransitDeliveriesList from '~components/TrackingInTransitDeliveriesList';
// eslint-disable-next-line max-len
import { TrackingInTransitDeliveriesItemBase } from '~components/TrackingInTransitDeliveriesList/types';
import { getDefaultAvatar } from '~utils/user';

import { useDashboardVariantV2CarrierContentCollectTrackingContext } from '../../../Context';

type DriversDeliveryExtraData = Pick<
  RouteReportCollectedItemsDriver,
  'driverId'
>;

const DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabDrivers =
  (): ReactElement => {
    const {
      tabsData: {
        data: tabsData,
        selectedDriverId: {
          value: selectedDriverId,
          setValue: setSelectedDriverId,
        },
      },
    } = useDashboardVariantV2CarrierContentCollectTrackingContext();

    const driversDeliveryData = useMemo<
      TrackingInTransitDeliveriesItemBase<DriversDeliveryExtraData>[]
    >(() => {
      if (!tabsData?.collectedItemsByDriver) return [];

      return tabsData.collectedItemsByDriver.map((driver) => ({
        label: driver.driverName,
        totalCount: driver.totalCollected,
        standarCount: driver.totalCollectedNoFlex,
        flexCount: driver.totalCollectedFlex,
        avatar: {
          src: getDefaultAvatar(driver.avatarUrl || undefined),
          alt: driver.driverName,
        },
        extraData: {
          driverId: driver.driverId,
        },
        isSelected: selectedDriverId === driver.driverId,
      }));
    }, [tabsData?.collectedItemsByDriver, selectedDriverId]);

    const handleClickItem = useCallback(
      (extraData: DriversDeliveryExtraData) => {
        setSelectedDriverId(extraData.driverId);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [],
    );

    return (
      <TrackingInTransitDeliveriesList
        data={driversDeliveryData}
        onClickItem={handleClickItem}
      />
    );
  };

export default DashboardVariantV2CarrierContentCollectTabTrackingSelectionTabDrivers;
